/**
 * @file RepRefreshButton.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-09-07
 * @modified 2026-09-07
 *
 * Recompute one card.
 *
 * The rep dashboard is served from a cache warmed at 07:00, so every card is
 * showing an answer computed before anyone was at a desk. That is right for
 * figures about completed months, and wrong the moment somebody wants to know
 * whether the thing they just did has landed — so each card says when it was
 * computed and offers to do it again.
 *
 * The timestamp is not decoration. A cached card with no indication that it is
 * cached is how somebody concludes the system is broken because their morning's
 * order is not in it.
 */

import React from 'react';
import './RepWidgets.css';

/** "07:04" today, "Fri 07:04" if it somehow predates today. */
function when(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  const time = d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
  const sameDay = d.toDateString() === new Date().toDateString();
  return sameDay ? time : `${d.toLocaleDateString('en-GB', { weekday: 'short' })} ${time}`;
}

function RepRefreshButton({ cachedAt, loading = false, onRefresh }) {
  const stamp = when(cachedAt);
  return (
    <button
      type="button"
      className="rep-refresh-btn"
      onClick={onRefresh}
      disabled={loading}
      title={stamp ? `Last updated ${stamp} — refresh now` : 'Refresh'}
    >
      <span className={`material-symbols-rounded${loading ? ' spinning' : ''}`}>refresh</span>
      {stamp && <span className="rep-refresh-stamp">{stamp}</span>}
    </button>
  );
}

export default RepRefreshButton;
